module.exports = __webpack_public_path__ + "static/LOGO-2-6cd49d5f31fd2c7c2cc36b6c403e92c6.svg";